import {initProductTile, initSlotCarousel} from './productTileComponent/productTile';
import NotifyHelper from './product/notify';

window.productTileComponent = { initSlotCarousel: initSlotCarousel };

document.addEventListener('DOMContentLoaded', () => {
    initProductTile();
    NotifyHelper.notifyMeModal();
});
